import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";

export const getInfoDetails = (influencer: IBriefInfluencerV2) => {
  const isAgency = Boolean(influencer.primaryContact?.agencyUserId);
  return {
    name: influencer.influencerName,
    dp: influencer.socialMedia?.profilePicUrl,
    rating: influencer.influencer?.avgReview || 5,
    phone: isAgency
      ? `${influencer.primaryContact?.agencyUser?.countryCode} ${influencer.primaryContact?.agencyUser?.phoneNumber}`
      : `${influencer.primaryContact?.countryCode} ${influencer.primaryContact?.phoneNumber}`,
    email: isAgency
      ? influencer.primaryContact?.agencyUser?.emailId
      : influencer.primaryContact?.emailId,
    location: (influencer.influencer?.location || []).join(", "),
    type: influencer.influencer?.type,
    isVerified: influencer.socialMedia?.searchV1?.isVerified,
    link: influencer.socialMedia?.link,
    username: influencer.socialMedia?.username,
    platform: influencer.socialMedia?.platform,
    agency: influencer.influencer?.agency?.companyName,
  };
};
